// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ttysix-preview-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #e8e6e3;
}

/* preview header */
.ttysix-preview-header {
  height: 46px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  background: #f5f3f1;
  border-bottom: 1px solid rgba(0,0,0,0.08);
}

.ttysix-preview-header__dots {
  letter-spacing: 3px;
  color: #8eb9b2;
}

.ttysix-preview-header__label {
  font-size: 12px;
  color: #6b666b;
}

/* scrollable canvas: center horizontal, align content to top */
.ttysix-preview-canvas {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: auto;

  display: flex;
  justify-content: center;
  align-items: flex-start;

  padding: 0 0 40px 0;
}

/* image at 1:1 pixel size (natural dimensions), no scaling */
.ttysix-preview-image {
  display: block;
  width: auto;
  height: auto;
  max-width: none;
  max-height: none;
  object-fit: none;
  vertical-align: top;
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/CollectivePreviewPageTwo.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;;EAEhB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;;EAEvB,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".ttysix-preview-page {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: #e8e6e3;\n}\n\n/* preview header */\n.ttysix-preview-header {\n  height: 46px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 14px;\n  background: #f5f3f1;\n  border-bottom: 1px solid rgba(0,0,0,0.08);\n}\n\n.ttysix-preview-header__dots {\n  letter-spacing: 3px;\n  color: #8eb9b2;\n}\n\n.ttysix-preview-header__label {\n  font-size: 12px;\n  color: #6b666b;\n}\n\n/* scrollable canvas: center horizontal, align content to top */\n.ttysix-preview-canvas {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: auto;\n\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n\n  padding: 0 0 40px 0;\n}\n\n/* image at 1:1 pixel size (natural dimensions), no scaling */\n.ttysix-preview-image {\n  display: block;\n  width: auto;\n  height: auto;\n  max-width: none;\n  max-height: none;\n  object-fit: none;\n  vertical-align: top;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
